module.exports = __webpack_public_path__ + "img/baumfaellung.59188c23.svg";